import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { styles } from "./styles";
import { Grid, Box, Typography } from "@mui/material";
import KpiCard from 'components/KpiCard/KpiCard';
import GreenCheck from "assets/icons/GreenCheck.svg";
import Stop from "assets/icons/Stop.svg";
import Truck from "assets/icons/Truck.svg";
import SP from "assets/icons/Roles.svg";
import { AgChartsReact } from 'ag-charts-react';
import {AgCartesianSeriesTooltipRendererParams} from 'ag-charts-community';
import {
  getAllDeviceByStatus,
  getTotalTrucks,
  getAllSPCount,
  getAlldevicecountbysp,
  getAlltruckcountbysp,
  getAllMissingHeartBeatForDeviceBySP
} from 'apis/device';
import { BarChart } from 'components/BarChart/BarCahrt';
import $ from 'jquery';

interface DashboardProps {
}

const Dashboard: React.FC<DashboardProps> = () => {

  const [devicesByStatus, setDevicesByStatus] = useState<any>(null);
  const [totalTrucks, setTotalTrucks] = useState<any>({});
  const [totalCollection, setTotalCollection] = useState<any>({});
  const [maintenance, setMaintenance] = useState<any>({});
  const [allSPCount, setAllSPCount] = useState<any>({});
  const [deviceCountbySP, setdeviceCountbySP] = useState<any>([]);
  const [staticCountbySP, setstaticCountbySP] = useState<any>([]);
  const [truckcountbySP, setTruckcountbySP] = useState<any>([]);
  const [stattictruckcountbySP, setStattictruckcountbySP] = useState<any>([]);
  const [missingHeartBeatbySP, setMissingHeartBeatbySP] = useState<any>([]);
  const [staticMissingHeartbeatCountBySP, setStaticMissingHeartbeatCountBySP] = useState<any>([]);
  const [pieChartOptions, setPieChartOptions] = useState<any>({});
  const [pieChartrucktOptions, setPieChartrucktOptions] = useState<any>({});
  const [pieCharmissingHeartbeatOptions, setPieCharmissingHeartbeatOptions] = useState<any>({});
  const [activeCount,setAciveCount] = useState<any>(0);
  const [inactiveCount,setInactiveCount] = useState<any>(0);

  useEffect(() => {
    getTotalDevicesByStatus();
    getAllTrucks();
    getTotalSPCount();
    getDeviceCountBySP();
    getTruckCountBySP();
    getMissingHeartBeatForDeviceBySP();
  }, []);

  const getTotalDevicesByStatus = async () => {
    let devicedata = await getAllDeviceByStatus();
    if (devicedata?.response?.devicedata?.errorMessage) {
      return
    }
   
    if (devicedata && devicedata.length >= 0) {
       devicedata.forEach((object: any) => {
        if(object.propName === 'Active'){
            setAciveCount(object.numValue);
        }
        if(object.propName === 'Inactive'){
          setInactiveCount(object.numValue);
      }
        
      });
      setDevicesByStatus(devicedata);
    }
  }

  const getAllTrucks = async () => {
    let trucksdata = await getTotalTrucks();
    if (trucksdata?.response?.data?.errorMessage) {
      return
    }
    if (trucksdata) {
      setTotalTrucks(trucksdata);
      setTotalCollection(trucksdata);
      setMaintenance(trucksdata)
    }
  }
  const getTotalSPCount = async () => {
    let spdata = await getAllSPCount();
    if (spdata?.response?.spdata?.errorMessage) {
      return
    }
    if (spdata) {
      setAllSPCount(spdata);
    }
  }

  const getDeviceCountBySP = async () => {
    let data = await getAlldevicecountbysp();
    if (data?.response?.data?.errorMessage) {
      return
    }
    if (data && data.length > 0) {
      let newData = data.slice(0,10); // first 9 records only visible to chart.
      setdeviceCountbySP(newData);
      setstaticCountbySP(data);
    }
  }

  const getTruckCountBySP = async () => {
    let data = await getAlltruckcountbysp();
    if (data?.response?.data?.errorMessage) {
      return
    }
    if (data && data.length > 0) {
       let newTruckData = data.slice(0, 10);
      setTruckcountbySP(newTruckData);
      setStattictruckcountbySP(data);
    }
  }

  const getMissingHeartBeatForDeviceBySP = async () => {
    let data = await getAllMissingHeartBeatForDeviceBySP();
    // console.log(data);
    if (data?.response?.data?.errorMessage) {
      return
    }
    if (data && data.length > 0) {
       let newTruckData = data.slice(0, 10);
      setMissingHeartBeatbySP(newTruckData);
      setStaticMissingHeartbeatCountBySP(data);
    }
  }

  const CreateDeviceChart = () => {
    setPieChartOptions({
      data: deviceCountbySP,
      series: [
        {
          type: 'pie',
          angleKey: 'numValue',
          calloutLabelKey: 'propName',
          calloutLabel: {
            enabled: false,
          },
          tooltip: {
            renderer: function (params: AgCartesianSeriesTooltipRendererParams) {
              return { content: params.datum.propName + ': ' + params.datum.numValue };
            }
          },
          sectorLabelKey: 'numValue',
          sectorLabel: {
            color: 'white',
            fontWeight: 'bold',
          },
          fills: ['#4258c9', '#f3622d', '#fba71b', '#57b757', '#41a9c9', '#9a42c8', '#c84164', '#888888','#aaac28','#2add45'],
          strokeWidth: 0
        },  
        
      ],
      legend: {
        position: 'right',
        item: {
          paddingX: 16,
          label: {
            fontSize: 12,
            fontWeight: '500',
            color: '#4C4C4B',
            maxLength: 25
          },
          marker: {
            size: 9,
            strokeWidth: 0,
            shape: 'square'
          }
        }
      }
    });
  }
 
 
  const CreateTruckChart = () => {
    setPieChartrucktOptions({
      data: truckcountbySP,
      series: [
        {
          type: 'pie',
          angleKey: 'numValue',
          calloutLabelKey: 'propName',
          calloutLabel: {
            enabled: false,
          },
          tooltip: {
            renderer: function (params: AgCartesianSeriesTooltipRendererParams) {
              return { content: params.datum.propName + ': ' + params.datum.numValue };
            }
          },
          sectorLabelKey: 'numValue',
          sectorLabel: {
            color: 'white',
            fontWeight: '600',
          },
          fills: ['#4258c9', '#f3622d', '#fba71b', '#57b757', '#41a9c9', '#9a42c8', '#c84164', '#888888','#aaac28','#2add45'],
          strokeWidth: 0
        }
      ],
      legend: {
        position: 'right',
        item: {
          paddingX: 16,
          label: {
            fontSize: 12,
            fontWeight: '500',
            color: '#4C4C4B',
            maxLength: 25
          },
          marker: {
            size: 9,
            strokeWidth: 0,
            shape: 'square'
          }
        }
      },

    })
  }

  const CreateMissingHeartbeatinlast24hrsChart = () => {
    setPieCharmissingHeartbeatOptions({
      data: missingHeartBeatbySP,
      series: [
        {
          type: 'pie',
          angleKey: 'numValue',
          calloutLabelKey: 'propName',
          calloutLabel: {
            enabled: false,
          },
          tooltip: {
            renderer: function (params: AgCartesianSeriesTooltipRendererParams) {
              return { content: params.datum.propName + ': ' + params.datum.numValue };
            }
          },
          sectorLabelKey: 'numValue',
          sectorLabel: {
            color: 'white',
            fontWeight: '600',
          },
          fills: ['#4258c9', '#f3622d', '#fba71b', '#57b757', '#41a9c9', '#9a42c8', '#c84164', '#888888','#aaac28','#2add45'],
          strokeWidth: 0
        }
      ],
      legend: {
        position: 'right',
        item: {
          paddingX: 16,
          label: {
            fontSize: 12,
            fontWeight: '500',
            color: '#4C4C4B',
            maxLength: 25
          },
          marker: {
            size: 9,
            strokeWidth: 0,
            shape: 'square'
  }
        }
      },

    })
  }
  

  useEffect(() => {
    CreateDeviceChart();
    CreateTruckChart();
    CreateMissingHeartbeatinlast24hrsChart();
    setInterval(() => {
      $('.ag-chart-no-data-overlay').remove();
    }, 100);
    return () => {
    }
    // eslint-disable-next-line
  }, [deviceCountbySP, truckcountbySP,missingHeartBeatbySP]);


  return (
    <div style={{ flexGrow: 1 }}>
      <Grid container spacing={2} sx={styles.cardContainer}>
        <Grid item xs={3}><KpiCard label={"Active Devices"} value={activeCount !== "" && activeCount} icon={GreenCheck} label1='' label2='' value1='' value2='' /></Grid>
        <Grid item xs={3}><KpiCard label={"Inactive Devices"} value={inactiveCount !== "" && inactiveCount} icon={Stop} label1='' label2='' value1='' value2='' /></Grid>
        <Grid item xs={3}>
          <KpiCard label={"Trucks"} label1={'Collection'} label2={'Maintenance'} value={totalTrucks && totalTrucks.numValue} icon={Truck}
            value1={totalCollection && totalCollection.collection } value2={maintenance && maintenance.other }/>
          
        </Grid>
        <Grid item xs={3}>
          <KpiCard label={"Service Providers"} value={allSPCount && allSPCount.numValue} icon={SP} label1='' label2='' value1='' value2='' />
        </Grid>
        <Grid item xs={5}>
          <Box sx={styles.boxContainer}>
            <Grid container sx={{ position: 'relative' }}>
              <Grid item xs={7} sx={{ fontWeight: '600', color: '#7C7B7B' }}>
              Top 10 Service Provider by Devices
              </Grid>
              <Grid item xs={3} sx={styles.subTitle} style={{right: '160px'}}>Top 10 Providers</Grid>
              <Grid item xs={2} sx={styles.subTitleRht}>Devices</Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={10}>
                    <AgChartsReact options={pieChartOptions} id="1" />
                  </Grid>
                  <Grid item xs={2} sx={styles.FlexCont}>
                    {staticCountbySP && staticCountbySP.slice(0, 10).map((item: any, i: any) => {
                      return <p style={{ fontSize: '11px', paddingLeft: '10px', fontWeight: '600', color: '#7C7B7B', lineHeight: '1.13rem'}} key={i}>{item.numValue}</p>
                     
                    })}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={7}>
          <Box sx={styles.boxContainer}>
            <Grid container sx={{ position: 'relative' }}>
              <Grid item xs={7} sx={{ fontWeight: '600', color: '#7C7B7B' }}>
              Top 10 Service Provider by Trucks
              </Grid>
              <Grid item xs={3} sx={styles.subTitle} style={{right: '300px'}}>Top 10 Providers</Grid>
              <Grid item xs={2} sx={styles.subTitleRht} style={{right: '225px'}}>Trucks</Grid>
              <Grid item xs={2} sx={styles.subTitleRht} style={{ right: '130px'}}>Collection</Grid>
              <Grid item xs={2} sx={styles.subTitleRht} style={{right: '20px'}}>Maintenance</Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={8}>
                    <AgChartsReact options={pieChartrucktOptions} id="2" />
                  </Grid>
                  <Grid item xs={4} sx={styles.FlexCont}>
                    <Grid container>
                    {stattictruckcountbySP && stattictruckcountbySP.slice(0, 10).map((item: any, i: any) => {
                      return (<>
                        <Grid item xs={4}>
                        <p style={{ fontSize: '11px', fontWeight: '600', color: '#7C7B7B', lineHeight: '1.18rem' }} key={i}>{item.numValue}</p>
                        </Grid>
                        <Grid item xs={4}>
                        <p style={{ fontSize: '11px', fontWeight: '600',  color: '#7C7B7B', lineHeight: '1.18rem' }} key={i}>{item.collection}</p>
                        </Grid>
                        <Grid item xs={4}>
                        <p style={{ fontSize: '11px', fontWeight: '600',  color: '#7C7B7B', lineHeight: '1.18rem' }} key={i}>{item.other}</p>
                        </Grid>
                          
                      </>)
                    })}
                      </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={5}>
          <Box sx={styles.boxContainer}>
            <Grid container sx={{ position: 'relative' }}>
              <Grid item xs={7} sx={{ fontWeight: '600', color: '#7C7B7B' }}>
              No Heartbeat in the past 24 hours
              </Grid>
              <Grid item xs={3} sx={styles.subTitle} style={{right: '150px'}}>Top 10 Providers</Grid>
              <Grid item xs={2} sx={styles.subTitleRht}>Devices</Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={10}>
                    <AgChartsReact options={pieCharmissingHeartbeatOptions} id="2" />
                  </Grid>
                  <Grid item xs={2} sx={styles.FlexCont}>
                    {staticMissingHeartbeatCountBySP && staticMissingHeartbeatCountBySP.slice(0, 10).map((item: any, i: any) => {
                      return <p style={{ fontSize: '11px', fontWeight: '600', paddingLeft: '10px', color: '#7C7B7B', lineHeight: '1.18rem' }} key={i}>{item.numValue}</p>
                    })}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12}>
           <BarChart />
        </Grid>
      </Grid>
    </div>
  )
}

export default Dashboard;